import { computed } from 'vue'
import type { RouteLocationAsRelativeGeneric } from 'vue-router'

import { useUserStore } from '@backmarket/nuxt-layer-oauth/useUserStore'
import type { I18nDefinition } from '@backmarket/nuxt-module-i18n/types/i18n'
import { useI18nLocale } from '@backmarket/nuxt-module-i18n/useI18nLocale'
import type { Variants } from '@ds/components/Button'

import { AdminRoutes } from '~/scopes/admin/route-names'
import { HOME } from '~/scopes/home/route-names'

import translations from './useAdminButton.translations'

export type AdminButtonConfig = {
  label: I18nDefinition
  redirection: RouteLocationAsRelativeGeneric
  variant: Variants
}

export function useAdminButton() {
  const locale = useI18nLocale()
  const { user, isUserAuthenticatedStaff } = useUserStore()

  const buttonConfig = computed((): AdminButtonConfig | null => {
    if (user.value.isShadowingClient) {
      return {
        label: translations.customerButtonLabel,
        redirection: { name: AdminRoutes.HOME },
        variant: 'primaryDestructive',
      }
    }

    if (user.value.isShadowingMerchant) {
      return {
        label: translations.sellerButtonLabel,
        redirection: { name: AdminRoutes.HOME },
        variant: 'primaryDestructive',
      }
    }

    if (isUserAuthenticatedStaff.value) {
      return {
        label: translations.adminButtonLabel,
        redirection: { name: HOME, params: { locale } },
        variant: 'brand',
      }
    }

    return null
  })

  const isAdminButtonVisible = computed(() => buttonConfig.value !== null)

  return { isAdminButtonVisible, buttonConfig }
}
